import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';

document.addEventListener('focusin', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.classList.contains('mantine-NumberInput-input')) return;
  window.setTimeout(() => {
    if (document.activeElement === input) input.setSelectionRange(0, input.value.length);
  }, 0);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
